module.exports = __webpack_public_path__ + "img/go.d43d1ddd.png";